import { render, staticRenderFns } from "./JEllipsis.vue?vue&type=template&id=4de15389&scoped=true&"
import script from "./JEllipsis.vue?vue&type=script&lang=js&"
export * from "./JEllipsis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de15389",
  null
  
)

export default component.exports